import { render, staticRenderFns } from "./IADetails.vue?vue&type=template&id=5b30196b"
import script from "./IADetails.vue?vue&type=script&lang=js"
export * from "./IADetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports